module.exports = __webpack_public_path__ + "img/x-diamond.102df521.svg";